import classNames from "components/ui/classNames";
import { FormattedMessage } from "react-intl";

interface VariationColumnProps {
  variation: number;
}
export default function VariationColumn({ variation }: VariationColumnProps) {
  const percentageFormatter = new Intl.NumberFormat("en-US", {
    style: "percent",
    notation: Math.abs(variation) > 1000 ? "compact" : "standard",
    maximumSignificantDigits: 2,
  });

  return (
    <div className="flex flex-col">
      <h1
        className={classNames("text-xl font-bold text-slate-600 ", {
          "text-emerald-600 dark:text-emerald-400": variation > 0,
          "text-slate-600 dark:text-slate-400": variation === 0,
          "text-red-600 dark:text-red-400": variation < 0,
        })}
      >
        {variation > 0 ? "+" : ""}
        {percentageFormatter.format(variation)}
      </h1>
      <p className="text-xs font-medium text-gray-500 dark:text-slate-400">
        <FormattedMessage
          defaultMessage="Variação"
          id="TcGNHj"
          description="Variação em % da popup da tabela de balanços"
        />
      </p>
    </div>
  );
}
